function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M791.37 3.94v678.85c0 82.86-55.43 143.14-131.71 143.14h-172c-56.29 0-84.86 43.43-90 78-5.14-34.57-33.71-78-90.29-78H135.65c-76.29 0-131.71-60.29-131.71-143.14V3.94h787.43z",
  fill: "#149adb",
  fillRule: "evenodd"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d52b1e",
  fillRule: "evenodd",
  d: "M791.37 167.08H3.94V3.94h787.43v163.14z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  fillRule: "evenodd",
  d: "M266.51 216.22H135.08v-49.14h131.43v49.14h0zM397.65 216.22H266.51v-49.14h131.14v49.14h0zM528.79 216.22H397.65v-49.14h131.14v49.14h0zM659.94 216.22H528.79v-49.14h131.15v49.14h0zM791.37 216.22H659.94v-49.14h131.43v49.14h0zM135.08 216.22H3.94v-49.14h131.14v49.14h0z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  fillRule: "evenodd",
  d: "M331.94 167.08H200.79v-49.43h131.15v49.43h0zM463.37 167.08H331.94v-49.43h131.43v49.43h0zM594.51 167.08H463.37v-49.43h131.14v49.43h0zM725.65 167.08H594.51v-49.43h131.14v49.43h0zM791.37 167.08h-65.72v-49.43h65.72v49.43h0zM69.65 167.08H3.94v-49.43h65.71v49.43h0zM102.22 117.65H36.79V68.51h65.43v49.14h0zM200.79 167.08H69.65v-49.43h131.14v49.43h0zM233.65 117.65h-65.71V68.51h65.71v49.14h0zM364.79 117.65h-65.71V68.51h65.71v49.14h0zM495.94 117.65h-65.43V68.51h65.43v49.14h0zM627.37 117.65h-65.72V68.51h65.72v49.14h0zM758.51 117.65h-65.72V68.51h65.72v49.14h0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M791.37 3.94v678.85c0 82.86-55.43 143.14-131.71 143.14h-172c-56.29 0-84.86 43.43-90 78-5.14-34.57-33.71-78-90.29-78H135.65c-76.29 0-131.71-60.29-131.71-143.14V3.94h787.43z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 7.87
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M103.37 287.65a42.55 42.55 0 0167.14 52.29c-14.57 18.57-41.43 22-59.71 7.43a42.41 42.41 0 01-7.43-59.71h0zm-9.43 81.14a69.61 69.61 0 10-12-97.71 69.59 69.59 0 0012 97.71h0z",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  fillRule: "evenodd"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M497.08 785.94c-5.43-4.29-9.43-8.86-10.86-18 16 1.14 35.43 9.14 68 6.86 43.43-3.43 52-17.14 74-33.43 15.71-11.43 32.29-11.14 47.43-6.57-8.29-13.14-12.57-29.43-5.14-47.14 10.29-25.43 21.71-37.14 14.29-80-5.43-32.29-18-49.14-22.86-64.57 9.14-.57 14.57 2.29 20 6.29-2.86-8.29-26-42-45.43-54.86 5.43 13.71-3.14 56.29 1.71 68.86 6-8 10-14.86 15.14-16.86 2.86 6.57 18.29 56.57 3.14 80.29-15.43 24.57-43.71 27.71-76 6.29-24.86-16.57-304-222.86-358.86-264.86 10-19.14 4.57-42.57-13.14-56.29-19.71-15.71-48.57-12-64 7.71a45.82 45.82 0 007.71 64.29c17.71 13.71 41.71 13.43 57.71-.86 54.29 42.86 321.71 264 343.71 284.29 28.86 26.29 32.29 54.29 12.29 75.14-19.43 20.57-71.71 17.71-78.57 16.29.57-5.43 6.29-10.86 12.57-18.57-13.43-1.71-52.57 16.86-67.14 14.86 16.86 15.71 55.43 30 64.29 30.86h0zM202.79 365.37a28.29 28.29 0 01-44.57-34.86c9.43-12.57 27.43-14.57 39.71-4.86a28.21 28.21 0 014.86 39.71h0z",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M135.65 356.22a42.47 42.47 0 1134.86-16.29 43.35 43.35 0 01-18 13.43 28.14 28.14 0 0010.57 16.86 23 23 0 007.71 4.29 65.14 65.14 0 0020.86-17.71 69.66 69.66 0 10-41.43 25.43 45.18 45.18 0 01-14.57-26h0zM288.79 435.08c-35.14 39.43-103.14 87.14-103.14 87.14l-14.86-21.14 85.43-95.14 85.43-95.43 22.57 12.29s-40 72.86-75.43 112.29h0z",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M323.65 330.51l27.72 14.86-27.72-14.86z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M323.65 330.51l27.72 14.86"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M316.79 338.22l29.15 15.72-29.15-15.72z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M316.79 338.22l29.15 15.72"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M309.94 345.65l30.85 16.86-30.85-16.86z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M309.94 345.65l30.85 16.86"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M188.79 481.08l17.72 25.71-17.72-25.71z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M188.79 481.08l17.72 25.71"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M195.65 473.37l18.86 27.42-18.86-27.42z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M195.65 473.37l18.86 27.42"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M202.51 465.94l20 28.85-20-28.85z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 22.93,
  strokeWidth: 4.5,
  d: "M202.51 465.94l20 28.85"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M135.08 735.94l10.86-8.86-7.71-10-11.14 8.57a19 19 0 00-21.71 1.43 18.92 18.92 0 0023.43 29.71 19 19 0 006.29-20.86h0z",
  fill: "#f3d400",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.5,
  fillRule: "evenodd"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M698.22 389.94a59 59 0 00-13.43-22.29 52.72 52.72 0 0018-9.71c26-20.29 30.29-57.71 10-83.71a59.81 59.81 0 00-83.71-10 61 61 0 00-13.43 15.14 63 63 0 00-18.57-18.29c-27.71-17.43-64.57-8.86-82.29 18.86-17.43 27.71-8.86 64.57 18.86 82.29a59.54 59.54 0 0034 8.86l-10.86 8.57-15.71 2.86-.57 9.71-6 4.86c-4.86-2.29-9.43-2.57-12.57-.29-2.86 2.29-3.71 6.86-2.57 12l-389.71 306 16.57 21.43 390-306c4.57 2.29 9.43 2.86 12.29.29 3.14-2.29 4-6.86 2.57-12l6.29-4.86 9.71 2 6.57-14.86 10.57-8.29a59.66 59.66 0 10114-2.57zm-43.71 57.71a40.69 40.69 0 01-31.14-2.29 41 41 0 01-18.29-55.14c.86-1.71 1.71-3.14 2.57-4.57l-9.43-12.57 13.43-10.57a19.82 19.82 0 0022.57-1.14c8.57-6.86 10.29-19.43 3.43-28a20.23 20.23 0 00-28-3.43 20.48 20.48 0 00-6.57 21.71l-13.43 10.57-9.71-12.29c-1.71.57-3.43 1.14-5.43 1.71a40.49 40.49 0 01-30.86-5.43 41.55 41.55 0 01-18.29-25.43c-2.29-10.86-.57-21.71 5.43-30.86a40.74 40.74 0 0156.29-13.14 41.07 41.07 0 0118.29 25.71 72.44 72.44 0 011.14 8.29l18.57-.57a41 41 0 1132 40.86l-4.86 18c2.57.86 5.14 1.71 7.71 2.86a41.11 41.11 0 01-5.43 75.71z",
  fill: "#f3d400",
  fillRule: "evenodd"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M698.22 389.94a59 59 0 00-13.43-22.29 52.72 52.72 0 0018-9.71c26-20.29 30.29-57.71 10-83.71a59.81 59.81 0 00-83.71-10 61 61 0 00-13.43 15.14 63 63 0 00-18.57-18.29c-27.71-17.43-64.57-8.86-82.29 18.86-17.43 27.71-8.86 64.57 18.86 82.29a59.54 59.54 0 0034 8.86l-10.86 8.57-15.71 2.86-.57 9.71-6 4.86c-4.86-2.29-9.43-2.57-12.57-.29-2.86 2.29-3.71 6.86-2.57 12l-389.71 306 16.57 21.43 390-306c4.57 2.29 9.43 2.86 12.29.29 3.14-2.29 4-6.86 2.57-12l6.29-4.86 9.71 2 6.57-14.86 10.57-8.29a59.66 59.66 0 10114-2.57h0zm-43.71 57.71a40.69 40.69 0 01-31.14-2.29 41 41 0 01-18.29-55.14c.86-1.71 1.71-3.14 2.57-4.57l-9.43-12.57 13.43-10.57a19.82 19.82 0 0022.57-1.14c8.57-6.86 10.29-19.43 3.43-28a20.23 20.23 0 00-28-3.43 20.48 20.48 0 00-6.57 21.71l-13.43 10.57-9.71-12.29c-1.71.57-3.43 1.14-5.43 1.71a40.49 40.49 0 01-30.86-5.43 41.55 41.55 0 01-18.29-25.43c-2.29-10.86-.57-21.71 5.43-30.86a40.74 40.74 0 0156.29-13.14 41.07 41.07 0 0118.29 25.71 38.64 38.64 0 011.14 8.29l18.57-.57a41 41 0 1132 40.86l-4.86 18c2.57.86 5.14 1.71 7.71 2.86a41.11 41.11 0 01-5.43 75.71h0z",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.5
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fill: "#f3d400",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.5,
  fillRule: "evenodd",
  d: "M139.94 682.22l12 15.15 28.85-22.86-11.71-15.14-29.14 22.85h0z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#f3d400",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4.5,
  fillRule: "evenodd",
  d: "M191.94 636.22l-10.86-1.43-1.14-14.28-22.29-28.29-16.28 12.86 20.85 26.57-15.71 12.29-20.86-26.57-16.28 12.57 20.85 26.85-15.71 12-20.86-26.57-16.28 12.86 22.28 28.29 13.43 4.57-1.14 10.85 4 2.29 77.14-60.57-1.14-4.29h0z"
});

function SvgCoa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 795.3,
    height: 907.87
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

export default SvgCoa;